var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-widget-template-gallery" }, [
    _c("div", { staticClass: "chat-widget-template-gallery__header" }, [
      _c("div", { staticClass: "chat-widget-template-gallery__toggle-links" }, [
        _c(
          "a",
          {
            class: {
              "chat-widget-template-gallery__link--active": _vm.allSelected,
            },
            on: { click: _vm.selectAll },
          },
          [_vm._v("All")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "chat-widget-template-gallery__separator" }, [
          _vm._v("·"),
        ]),
        _vm._v(" "),
        _c("a", { on: { click: _vm.clearAll } }, [_vm._v("Clear")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "chat-widget-template-gallery__counter" }, [
        _vm._v("\n      " + _vm._s(_vm.selectedIds.length) + " selected\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "chat-widget-template-gallery__grid" },
      _vm._l(_vm.templates, function (tpl) {
        return _c(
          "div",
          {
            key: tpl.id,
            class: [
              "chat-widget-template-gallery__card",
              {
                "chat-widget-template-gallery__card--selected": _vm.isSelected(
                  tpl.id
                ),
              },
            ],
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.toggleSelect(tpl.id)
              },
            },
          },
          [
            _c("div", { staticClass: "chat-widget-template-gallery__thumb" }, [
              _c(
                "button",
                {
                  staticClass: "chat-widget-template-gallery__preview",
                  attrs: {
                    type: "button",
                    title: "Preview",
                    "aria-label": "Preview template",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openPreview(tpl)
                    },
                  },
                },
                [_c("i", { staticClass: "bi bi-arrows-angle-expand" })]
              ),
              _vm._v(" "),
              _c("img", {
                staticClass: "chat-widget-template-gallery__img",
                attrs: { src: tpl.thumbnail, alt: tpl.name },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.toggleSelect(tpl.id)
                  },
                },
              }),
              _vm._v(" "),
              _vm.isSelected(tpl.id)
                ? _c(
                    "div",
                    { staticClass: "chat-widget-template-gallery__check" },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "12",
                            height: "12",
                            fill: "currentColor",
                            viewBox: "0 0 16 16",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z",
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "chat-widget-template-gallery__name" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.getStyleLabel(tpl) || tpl.name) +
                  "\n      "
              ),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "chat-widget-template-gallery__footer" }, [
      _c(
        "button",
        {
          staticClass: "chat-widget-template-gallery__create-btn",
          attrs: { disabled: _vm.disabled || _vm.selectedIds.length === 0 },
          on: { click: _vm.onCreateImages },
        },
        [
          _vm._v(
            "\n      Create " +
              _vm._s(_vm.selectedIds.length) +
              " " +
              _vm._s(_vm.selectedIds.length === 1 ? "image" : "images") +
              "\n      "
          ),
          _c("span", { staticClass: "chat-widget-template-gallery__arrow" }, [
            _vm._v("→"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "chat-widget-template-gallery__browse-link",
          on: {
            click: function ($event) {
              return _vm.$emit("action", "browse_gallery")
            },
          },
        },
        [_vm._v("\n      Browse in gallery "), _c("span", [_vm._v("→")])]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }